(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.headerSection = document.querySelector('.section-header');
      this.announcementSection = document.querySelector('.custom-marquee-main');

      if (!this.headerSection) return;

      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.announcementBounds = {};

      this.setHeights();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeights.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.headerSection.classList.add('shopify-section-header-sticky');
        if (this.announcementSection) {
          this.announcementSection.classList.add('shopify-section-announcement-sticky');
        }
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeights() {
      const announcementHeight = this.announcementSection ? this.announcementSection.offsetHeight : 0;
      const headerHeight = this.headerSection ? this.headerSection.offsetHeight : 0;

      document.documentElement.style.setProperty('--announcement-height', `${announcementHeight}px`);
      document.documentElement.style.setProperty('--header-height', `${announcementHeight + headerHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.target === this.announcementSection) {
            this.announcementBounds = entry.intersectionRect;
          } else if (entry.target === this.headerSection) {
            this.headerBounds = entry.intersectionRect;
          }
        });
        // Keep observing for dynamic changes, or disconnect if not needed
      }, { threshold: [0, 1] });

      if (this.announcementSection) observer.observe(this.announcementSection);
      observer.observe(this.headerSection);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Use announcement bottom if exists, else header bottom
      const referenceBottom = this.announcementSection ? 
        (this.announcementBounds.bottom || this.announcementSection.getBoundingClientRect().bottom + scrollTop) : 
        this.headerBounds.bottom;

      const referenceTop = this.announcementSection ? 
        this.announcementBounds.top : 
        this.headerBounds.top;

      if (scrollTop > this.currentScrollTop && scrollTop > referenceBottom) {
        this.headerSection.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > referenceBottom) {
        this.headerSection.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= referenceTop) {
        this.headerSection.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      if (this.announcementSection) {
        this.announcementSection.classList.add('shopify-section-announcement-hidden', 'shopify-section-announcement-sticky');
      }
      this.headerSection.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      if (this.announcementSection) {
        this.announcementSection.classList.add('shopify-section-announcement-sticky', 'animate');
        this.announcementSection.classList.remove('shopify-section-announcement-hidden');
      }
      this.headerSection.classList.add('shopify-section-header-sticky', 'animate');
      this.headerSection.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      if (this.announcementSection) {
        this.announcementSection.classList.remove('shopify-section-announcement-hidden', 'shopify-section-announcement-sticky', 'animate');
      }
      this.headerSection.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.headerSection.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.headerSection.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
